import React from "react"

import ItemDetailsColumns from "../../../common/columns/ItemDetailsColumns"
import ItemDetailsColumn from "../../../common/columns/ItemDetailsColumn"
import InsightAreaMediaEditWidget from "./InsightAreaMediaEditWidget"
import InsightAreaEditItemDetails from "./InsightAreaEditItemDetails"
import InsightAreaPlaceholderImageEditWidgetContainer from "./InsightAreaPlaceholderImageEditWidgetContainer"
import InsightAreaConceptMappingsEditWidgetContainer from "./InsightAreaConceptMappingsEditWidgetContainer"
import InsightAreaPermissionHoldersEditWidgetContainer from "./InsightAreaPermissionHoldersEditWidgetContainer"
import InsightAreaEditFingerprintWidgetContainer from "./InsightAreaEditFingerprintWidgetContainer"

const InsightAreaEditItem = ({
    media,
    model,
    onEventChange,
    onValueChange,
    onImageChange,
}) => (
    <ItemDetailsColumns className="insight-area-item-container">
        <ItemDetailsColumn>
            <InsightAreaEditItemDetails
                name={model.name}
                type={model.type}
                description={model.description}
                status={model.status}
                imageUrl={model.image_url}
                imagePreviewURL={model.imagePreviewURL}
                onEventChange={onEventChange}
                onImageChange={onImageChange}
            />
            <div className="article-placeholders">
                <InsightAreaPlaceholderImageEditWidgetContainer
                    placeholders={model.placeholders}
                />
            </div>
            <div className="permission-holders">
                <InsightAreaPermissionHoldersEditWidgetContainer />
            </div>
        </ItemDetailsColumn>
        <ItemDetailsColumn>
            <div id="topics-mappings">
                <InsightAreaConceptMappingsEditWidgetContainer
                    mappings={model.mappings}
                />
            </div>
            <InsightAreaEditFingerprintWidgetContainer
                isEditMode={true}
                showLoading={true}
            />
            <div>
                <InsightAreaMediaEditWidget
                    media={media}
                    onEventChange={onEventChange}
                    onValueChange={onValueChange}
                />
            </div>
        </ItemDetailsColumn>
    </ItemDetailsColumns>
)

export default InsightAreaEditItem
